import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import ProductsView from '../views/Products.vue'
import ProductDetailView from '../views/ProductDetail.vue'
import NewsView from '../views/News.vue'
import AboutView from '../views/About.vue'
import ContactView from '../views/Contact.vue'
import DownloadView from '../views/Download.vue'
import LoginView from '../views/Login.vue'
import PayView from '../views/Pay.vue'
import ForgotPasswordView from '../views/ForgotPassword.vue'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/download',
    name: 'download',
    component: DownloadView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPasswordView
  },
  {
    path: '/pay',
    name: 'pay',
    component: PayView
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component: ProductDetailView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  }
})

// 添加导航守卫处理非标准格式的URL
router.beforeEach((to, from, next) => {
  console.log('导航守卫触发，当前路径:', to.path);
  
  // 处理非标准格式的/home路径，如/home&phone=...
  if (to.path.startsWith('/home&')) {
    console.log('检测到非标准格式的/home路径，重定向到标准格式...');
    // 提取参数部分
    const params = to.path.substring(5); // 移除/home部分
    // 构建标准格式的URL
    const standardPath = `/home?${params}`;
    console.log('重定向到:', standardPath);
    // 重定向到标准格式的URL
    next({ path: standardPath });
  } else {
    // 正常导航
    next();
  }
})

export default router
